import { z } from "zod";

export const ProjetoSchema = z.object({
  idProjeto: z.number().optional(),
  idNovoNegocio: z.number().optional().nullable(),
  idCentroCusto: z.number().optional().nullable(),
  descricaoProjeto: z.string(),
  numeroContrato: z.string().optional().nullable(),
  contato: z.string().optional().nullable(),
  telefoneCelular: z.string().optional().nullable(),
  telefoneFixo: z.string().optional().nullable(),
  contato1: z.string().optional().nullable(),
  contato2: z.string().optional().nullable(),
  telefone1: z.string().optional().nullable(),
  telefone2: z.string().optional().nullable(),
  email1: z.string().optional().nullable(),
  email2: z.string().optional().nullable(),
  email: z.string().optional().nullable(),
  escopo: z.string().optional().nullable(),
  dadosEntrada: z.string().optional().nullable(),
  informacoes: z.string().optional().nullable(),
  responsavel: z.string().optional().nullable(),
  data: z.coerce.date().optional().nullable(),
  dataInicio: z.coerce.date().optional().nullable(),
  dataTermino: z.coerce.date().optional().nullable(),
  dataInicioreal: z.coerce.date().optional().nullable(),
  dataTerminoreal: z.coerce.date().optional().nullable(),
  delete: z.boolean().optional(),
  arquivo: z.instanceof(Uint8Array).optional().nullable(),
  nomearquivo: z.string().optional().nullable(),
});

export type ProjetoForm = z.infer<typeof ProjetoSchema>;
